import SpaceFolderTree from './SpaceFolderTree';

export default SpaceFolderTree;
